<template>
  <div class="container-fluid p-3">
    <ValidationObserver ref="form">
      <div class="row">
        <div class="col-12 col-md-2">
          <div class="font-weight-normal">
            Compra:
          </div>
          <div class="align-items-end d-flex p-0 pt-2 custom-radio-container">
            <CustomRadio
              ref="compra"
              :name="`compra_${value.bookId}`"
              :is-disabled="false"
              :change-event="onChangeCompra"
              :options="optionsYesNoList"
              :is-question-list="true"
              :error="!purchaseSelected"
              :custom-error-msg="resources['25044']"
            />
          </div>
        </div>

        <div class="col-12 col-md-10 mt-auto">
          <div class="row">
            <!-- Razón -->
            <div class="col-12 col-md-6 pt-3 pt-md-0">
              <div v-if="showPurchaseReason">
                <div class="font-weight-normal">
                  Razón:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="`${model.purchase != null ? 'required' : ''}`"
                >
                  <custom-drop-down
                    v-model="model.purchaseReason"
                    class="pt-2"
                    :name="`razon_${value.bookId}`"
                    fieldkey="id"
                    fieldname="value"
                    :clearable="false"
                    :options="purchaseReasonOptions"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25045']"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Razón -->

            <!-- Centro -->
            <div
              v-if="showPurchaseReason && showCenterDropdown"
              class="col-12 col-md-6 pt-3 pt-md-0"
            >
              <div>
                <div class="font-weight-normal">
                  Centro:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="
                    `${
                      showPurchaseReason && showCenterDropdown ? 'required' : ''
                    }`
                  "
                >
                  <custom-drop-down
                    v-model="model.center"
                    class="pt-2"
                    :name="`center_${value.bookId}`"
                    fieldkey="id"
                    fieldname="name"
                    :clearable="false"
                    :options="collections.centers"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25048']"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Centro -->

            <!-- Municipio -->
            <div class="col-12 col-md-6 pt-3 pt-md-0">
              <div v-if="showPurchaseReason && showMunicipalitySchool">
                <div class="font-weight-normal">
                  Municipio:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="
                    `${
                      showPurchaseReason && showMunicipalitySchool
                        ? 'required'
                        : ''
                    }`
                  "
                >
                  <custom-drop-down
                    v-model="model.municipality"
                    class="pt-2"
                    :name="`municipality_${value.bookId}`"
                    fieldkey="id"
                    fieldname="name"
                    :clearable="false"
                    :options="municipalities"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25046']"
                    @input="onMunicipalityChanged"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Municipio -->

            <!-- Escuela -->
            <div class="col-12 col-md-6 pt-3">
              <div v-if="showPurchaseReason && showMunicipalitySchool">
                <div class="font-weight-normal">
                  Escuela:
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="
                    `${
                      showPurchaseReason && showMunicipalitySchool
                        ? 'required'
                        : ''
                    }`
                  "
                >
                  <custom-drop-down
                    v-model="model.school"
                    class="pt-2"
                    :name="`school_${value.bookId}`"
                    fieldkey="id"
                    fieldname="name"
                    :clearable="false"
                    :options="schools"
                    placeholder="Seleccione"
                    :error="errors[0]"
                    :custom-error-msg="resources['25047']"
                  />
                </ValidationProvider>
              </div>
            </div>
            <!-- Escuela -->

            <!-- Acciones -->
            <div
              class="pt-3 mt-auto text-right"
              :class="showCenterDropdown ? 'col-12' : 'col-12 col-md-6'"
            >
              <action-button
                :text="cancelBtnText"
                i="fas fa-times-circle"
                variant="outline-danger btn-transparent"
                class="mx-1"
                @click="cancel"
              />
              <action-button
                :text="saveBtnText"
                i="fas fa-save"
                variant="success btn-transparent"
                @click="save"
              />
            </div>
            <!-- Acciones -->
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomRadio from 'custom-radio';
import ActionButton from 'ActionButton';
import purchaseReasonsConst from '@/utils/constants/book/purchaseReasons';
import locationService from '@/services/api/location.api.js';
import resourcesService from '@/services/resources.js';
import alert from '@/mixin/alert.mixin';
import { determineBook } from '@/modules/books-requests/api';
import { studentBookStatus } from '@/utils/constants/book/studentBookStatus';

export default {
  name: 'DetermineBook',
  mixins: [alert],
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomDropDown,
    CustomRadio,
    ActionButton,
  },
  data() {
    return {
      optionsYesNoList: [
        {
          id: true,
          name: 'question1',
          label: 'Si',
          check: false,
          invalid: false,
          disabled: false,
        },
        {
          id: false,
          name: 'question2',
          label: 'No',
          check: false,
          invalid: false,
          disabled: false,
        },
      ],
      purchaseReasonOptions: [
        { id: 0, value: 'Intercambio de Centro' },
        { id: 1, value: 'Intercambio de Escuela' },
        { id: 2, value: 'Inventario de Escuela' },
      ],
      purchaseSelected: true,
      resources: [],
      schools: [],
      municipalities: [],
      model: {
        purchase: null,
        purchaseReason: null,
        center: null,
        school: null,
        municipality: null,
      },
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    collections: {
      type: Object,
      required: true,
    },
  },
  computed: {
    saveBtnText() {
      let text = this.$store.getters.getIsMobileDensity ? '' : 'Guardar';
      return text;
    },
    cancelBtnText() {
      let text = this.$store.getters.getIsMobileDensity ? '' : 'Cancelar';
      return text;
    },
    showCenterDropdown() {
      return (
        this.model.purchaseReason &&
        this.model.purchaseReason?.id ==
          purchaseReasonsConst.IntercambioDeCentro
      );
    },
    showMunicipalitySchool() {
      return (
        this.model.purchaseReason &&
        this.model.purchaseReason?.id ==
          purchaseReasonsConst.IntercambioDeEscuela
      );
    },
    showPurchaseReason() {
      return this.model.purchase == false;
    },
  },
  watch: {
    'model.purchaseReason'(val) {
      if (val.id === 0) {
        this.model.municipality = null;
        this.model.school = null;
      } else if (val.id === 1) {
        this.model.center = null;
        this.getMunicipalities();
      } else {
        this.model.center = null;
        this.model.municipality = null;
        this.model.school = null;
      }
    },
  },
  methods: {
    onChangeCompra(item) {
      if (item.id) {
        this.model.purchaseReason = null;
        this.model.center = null;
        this.model.municipality = null;
        this.model.school = null;
      }

      this.purchaseSelected = true;
      this.model.purchase = item.id;
    },
    async onMunicipalityChanged(municipality) {
      if (municipality) {
        const { data } = await locationService.getSchools({
          academicYearId: this.value.academicYearId,
          municipalityId: this.model.municipality.id,
        });
        this.schools = data;
      }
    },
    async getMunicipalities() {
      const { data } = await locationService.getMunicipalities({
        academicYearId: this.value.academicYearId,
      });
      this.municipalities = data;
    },
    async save() {
      this.purchaseSelected = this.model.purchase != null;
      const valid = await this.$refs.form.validate();
      if (this.purchaseSelected && valid) {
        const book = {
          bookId: this.value.bookId,
          academicYearId: this.value.academicYearId,
          studentSieId: this.value.studentSieId,
        };

        if (this.model.purchase) {
          book.targetStatusId = studentBookStatus.PendienteCompra;

          determineBook(book)
            .then((res) => {
              if (res.status == 200) {
                this.ShowToast(
                  'Proceso exitoso.',
                  'Los datos fueron guardados exitosamente.',
                  'success'
                );
                this.refreshSearch();
              }
            })
            .catch((err) => {
              if (err && err.response && err.response.data) {
                this.ShowToast('Error', err.response.data.message, 'error');
              } else {
                this.ShowToast('Error', err.message, 'error');
              }
            });
        } else {
          let nextStatus = '';
          if (
            this.model.purchaseReason.id ==
              purchaseReasonsConst.IntercambioDeCentro ||
            this.model.purchaseReason.id ==
              purchaseReasonsConst.IntercambioDeEscuela
          ) {
            book.targetStatusId = studentBookStatus.PendienteEntregaEscuela;
            nextStatus = 'Pendiente Entrega Escuela';
          } else {
            book.targetStatusId = studentBookStatus.PendienteEntregaEstudiante;
            nextStatus = 'Pendiente Entrega Estudiante';
          }

          const answer = await this.ShowCancelModal(
            'Confirmación',
            `¿Está seguro que desea poder cambiar el estatus de Pendiente de Determinación CSEE a ${nextStatus}?`
          );
          if (answer) {
            determineBook(book)
              .then((res) => {
                if (res.status == 200) {
                  this.ShowToast(
                    'Proceso exitoso.',
                    'Los datos fueron guardados exitosamente.',
                    'success'
                  );
                  this.refreshSearch();
                }
              })
              .catch((err) => {
                if (err && err.response && err.response.data) {
                  this.ShowToast('Error', err.response.data.message, 'error');
                } else {
                  this.ShowToast('Error', err.message, 'error');
                }
              });
          }
        }
      } else {
        this.ShowToast(
          'Información Incompleta',
          'Favor de completar la información solicitada',
          'error'
        );
      }
    },
    refreshSearch() {
      const filters = this.$parent.$parent.filters;
      this.$parent.$parent.onSearch(filters);
      this.$emit('cancel-determine-book');
    },
    cancel() {
      this.$emit('cancel-determine-book');
    },
    async loadResources() {
      this.resources = await resourcesService.LoadValidationMessages([
        '25044',
        '25045',
        '25046',
        '25047',
        '25048',
      ]);
      this.getMunicipalities();
    },
  },
  async mounted() {
    await this.loadResources();
  },
};
</script>
